import { Injectable } from "@angular/core";
import { SystemVersion } from './system-version.model';
import { RestService } from "../../core/core/rest.service";
import { ObjectToSelect } from "../../core/shared/objectToSelect.model";


@Injectable()
export class SystemVersionRest {  
    constructor(private http: RestService) { }
    public getSystemVersions() {
        return this.http.get<SystemVersion[]>('api/systemversions');
    }

    public getSystemVersionsById(id: number) {
        let path = `api/systemversions/universaldictionary/${id}`;
        return this.http.get<SystemVersion[]>(path);
    }

    public getSystemVersion(systemversionId: number) {
        return this.http.get<SystemVersion>(`api/systemversion/${systemversionId}`);
    }

    public addSystemVersion(systemVersion: SystemVersion) {
        return this.http.post<SystemVersion>('api/systemversion/add', systemVersion);
    }

    public saveSystemVersion(systemVersion: SystemVersion) {
        return this.http.post<SystemVersion>('api/systemversion/edit', systemVersion);
    }

    public deleteSystemVersion(systemVersionId: number) {
        return this.http.post('api/systemversion/delete', systemVersionId );
    }

    public getSystemVersionsToSelect() {
        return this.http.get<ObjectToSelect[]>('api/systemversions/getSystemVersionsToSelect');
    }

}